import { useGetMediaFoldersQuery } from "@api/media-folders";
import Icon from "@components/ui/icon";
import { MediaLibCategoryEnum } from "@editor/modules/media-lib";
import { cn } from "@lib/cn";
import { useMemo } from "react";

interface IProps {
  title: string;
  folderId: string;
  folderLevel?: number;
  selectedFolderId: string | null;
  setSelectedFolderId: (id: string | null) => void;
}

export const MediaLibFileMoveDialogFolder = ({
  title,
  folderId,
  folderLevel = 0,
  selectedFolderId,
  setSelectedFolderId,
}: IProps) => {
  const { data: allFolders = [] } = useGetMediaFoldersQuery({
    archived: false,
  });

  const isActive = folderId === selectedFolderId;

  const subFolders = useMemo(() => {
    return allFolders.filter((el) => el.parentId === folderId);
  }, [allFolders, folderId]);

  return (
    <div className="tw-relative">
      <div
        className={cn(
          "tw-flex tw-h-9 tw-w-full tw-cursor-pointer tw-items-center tw-rounded tw-pr-3 tw-font-sans tw-text-[11px] tw-font-normal tw-text-blue tw-transition-colors",
          isActive ? "tw-bg-primary-50 tw-text-primary" : "hover:tw-bg-blue-50",
        )}
        style={{
          paddingLeft: 12 + (folderLevel > 0 ? 12 + folderLevel * 16 : 0),
        }}
        onClick={() => {
          setSelectedFolderId(folderId);
        }}
      >
        {folderLevel === 0 && (
          <Icon
            icon={
              folderId === MediaLibCategoryEnum.AllFiles
                ? "ri-folders-line"
                : folderId === MediaLibCategoryEnum.BrandAssets
                  ? "ri-briefcase-3-line"
                  : "ri-folder-line"
            }
            className={cn(
              "tw-mr-2 tw-text-blue-500",
              isActive && "tw-text-primary",
            )}
          />
        )}
        {title}
      </div>
      {subFolders.map((f) => (
        <MediaLibFileMoveDialogFolder
          key={f._id}
          folderId={f._id}
          title={f.title}
          folderLevel={folderLevel + 1}
          selectedFolderId={selectedFolderId}
          setSelectedFolderId={setSelectedFolderId}
        />
      ))}
    </div>
  );
};
